<app-digital-template-collection-list></app-digital-template-collection-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreateTemplateCollectionModal()">
    Create Template Collection
  </lib-button-primary>
</lib-button-input-portal>
